import { createContext, useMemo } from 'react';
import { useSafeContext } from '@mews/framework';
import { WithChildren } from '@optimus-web/common';
import { ProductCheckListFilterValues } from '../components/panels/ProductCheckListFilterFields/types';

interface ProductCheckListFiltersContextValue {
    filters: ProductCheckListFilterValues;
}

const ProductCheckListFiltersContext = createContext<ProductCheckListFiltersContextValue | null>(null);

ProductCheckListFiltersContext.displayName = 'ProductCheckListFiltersContext';

export const ProductCheckListFiltersContextProvider: React.FC<
    { filters: ProductCheckListFilterValues } & WithChildren
> = ({ children, filters }) => {
    const contextValue = useMemo(() => ({ filters }), [filters]);

    return (
        <ProductCheckListFiltersContext.Provider value={contextValue}>
            {children}
        </ProductCheckListFiltersContext.Provider>
    );
};

export const useProductCheckListFiltersContext = () => useSafeContext(ProductCheckListFiltersContext);
